import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { LetterShowClick, PracticalTrainingValidate, TransferInLetterValidate } from '../../../config/Validate';
import { defaultPageRowOptions, defaultRowOptions, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { getAllDetailsDirect, getSpecificDetailsById, postAllData } from '../../../service/ProductService';
import { DOWNLOADTRAININGLETTER, DOWNLOADTRANSFERLETTER, LETTERMASTERCOUNCILLIST, LETTERSMASTERHOSPITALLIST, STORETRAININGLETTER, STORETRANSFERLETTER, TRAININGLETTER, TRANSFERLETTER } from '../../../config/ApiConstant';
import { PracticalTrainingListColumns, TransferInLeterListColumns } from '../../../appconfig/DatatableSetting';
import { commonNameTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';

import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { LettersTab } from '../LettersTab';
import { OtherLetterTab } from './OtherLetterTab';
import { formatYearMonthDate } from '../../../appconfig/AppHelper';
import Loader from '../../../components/Loadeer/Loader';

export const PracticalTraining = () => {
    document.title = 'Letter To Hospital | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [errors, setErrors] = useState<any>({});
    const [regNo, setRegNo] = useState<any>(null);
    const [hospitalData, setHospitalData] = useState<any>({});
    const [addLoader, setAddLoader] = useState<boolean>(false);
    const [tansferInList, setTransferInList] = useState<any>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [buttonVisible, setButtonVisible] = useState<boolean>(true);
    const [hospitalOptions, setHospitalOptions] = useState<any>([]);
    const [selectedHospital, setSelectedHospital] = useState<any>(null);
    const [hospitalAddress, setHospitalAddress] = useState<any>([]);

    // useEffect
    useEffect(() => {
        transferInLetterList();
        getAllHospital();
    }, []);

    // Get University
    const getAllHospital = async () => {
        try {
            const response = await getAllDetailsDirect(LETTERSMASTERHOSPITALLIST + '?type=all');

            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setHospitalOptions([]);
                } else {
                    setHospitalAddress(DataList);

                    let councilData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const hospitalObj: any = {};
                        hospitalObj['name'] = DataList[i].HospName;
                        hospitalObj['code'] = DataList[i].HospNo;
                        councilData.push(hospitalObj);
                    }
                    setHospitalOptions(councilData);
                }
            } else {
                setHospitalOptions([]);
            }
        } catch (error: any) {
            setHospitalOptions([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // Clear all
    const clearAll = () => {
        transferInLetterList();
        setRegNo(null);
        setHospitalData({});
        setSelectedHospital(null);
        setErrors({});
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val = (e.target && e.target.value) || e.value || '';

        setHospitalData({ ...hospitalData, [name]: val });
    };

    // getUniversitLetterList
    const transferInLetterList = async () => {
        if (!window.cn(regNo)) {
            try {
                const response = await getAllDetailsDirect(TRAININGLETTER + '?FileNo=' + regNo);

                const { List } = response;
                if (!window.cn(response) && Object.keys(response?.Details).length !== 0) {
                    const { StudF, StudM, StudL } = response?.Details;
                    let FromNm = (!window.cn(StudL) ? StudL : '') + ' ' + (!window.cn(StudF) ? StudF : '') + ' ' + (!window.cn(StudM) ? StudM : '');
                    setHospitalData({
                        ...hospitalData,
                        Name: FromNm
                    });
                    setTransferInList(List);
                    setShowLoading(false);
                    setButtonVisible(false);
                    setSelectedHospital(null);
                } else {
                    setButtonVisible(true);
                    setShowLoading(false);
                    setHospitalData({});
                    setSelectedHospital(null);
                }
            } catch (error: any) {
                if (error.response) {
                    //Spinner False and Set Toast
                    setShowLoading(false);
                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
                }
            }
        } else {
            try {
                setPageLoad(false);
                const response = await getAllDetailsDirect(TRAININGLETTER);

                if (response) {
                    const { List } = response;
                    setTransferInList(List);
                    setPageLoad(true);
                }
            } catch (error: any) {
                if (error.response) {
                    //Spinner False and Set Toast
                    setPageLoad(true);

                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
                }
            }
        }
    };

    //\ onShowClick get User Deatsils
    const getUserDetails = async () => {
        try {
            const { errors, isError } = LetterShowClick(regNo);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setShowLoading(true);

                transferInLetterList();
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setShowLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };
    //onchange event
    const onCollegeSelect = (e: any) => {
        setSelectedHospital(e);
        gethospitalAddress(e);
    };

    //getUniversirtAddress
    const gethospitalAddress = (name: any) => {
        hospitalAddress.map((item: any) => {
            if (item?.HospNo === name?.code) {
                setHospitalData({ ...hospitalData, address: item?.Address ? item.Address : '' });
            }
        });
    };

    // Add inward data
    const addhospitalData = async () => {
        try {
            const { errors, isError } = PracticalTrainingValidate(hospitalData, selectedHospital, regNo);
            setErrors(errors);
            //Check Error if no errors then call API
            if (!isError) {
                setAddLoader(true);

                let requestData = { ...hospitalData };
                requestData['FileNo'] = Number(regNo);
                requestData['idhospital'] = selectedHospital?.code;
                requestData['HospitalNm'] = selectedHospital?.name;

                const response = await postAllData(STORETRAININGLETTER, requestData);
                if (response) {
                    setAddLoader(false);
                    toast.current?.show({ severity: 'success', summary: 'Message', detail: response?.data });
                    setHospitalData({});
                    clearAll();
                    transferInLetterList();
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setAddLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Template for actions
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button icon="pi pi-download" onClick={() => downloadTransferLetter(rowData?.SrNo)} tooltip="Download" tooltipOptions={{ position: 'top' }} />
                </div>
            </>
        );
    };

    // Download bank entry
    const downloadTransferLetter = async (id: any) => {
        try {
            setLoading(true);

            const response = await getSpecificDetailsById(DOWNLOADTRAININGLETTER, id);

            //Check response and download
            if (response) {
                //PDF Download
                const { file_url } = response;
   
                setLoading(false);

                //PDF Download
                const fileName = `Transfer-In-Letter-${new Date().getTime()}.pdf`;
                const link = document.createElement('a');
                link.href = file_url;
                link.target = '_blank';
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: error.response.data.error });
            }
        }
    };

    return (
        <>
            <LettersTab mainTabLabel="Other Letters" />
            <OtherLetterTab initialTabLabel="Letters To Hospital" />
            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <div className="p-fluid formgrid grid align-items-center">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="regNo">
                                    File No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(regNo) ? regNo : ''} name="regNo" keyfilter={'num'} autoComplete="off" placeholder="Enter File No." onChange={(e) => setRegNo(e.target.value)} className={errors['regNo'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['regNo']}</small>
                            </div>
                            <div className="field col-12 md:col-1 mt-4">
                                <Button label="Search" className="p-button-primary" onClick={() => getUserDetails()} loading={showLoading} />
                            </div>
                        </div>
                        <hr />
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="Name">
                                    Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(hospitalData?.Name) ? hospitalData?.Name : ''} name="Name" disabled={true} />
                            </div>

                            <div className="field col-12 md:col-4">
                                <label htmlFor="year">
                                    Year <span style={{ color: 'red' }}>*</span>
                                </label>

                                <InputText value={!window.cn(hospitalData?.year) ? hospitalData?.year : ''} name="year" onChange={(e) => onInputChange(e, 'year')} className={errors['year'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['year']}</small>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="hospitalName">
                                    Hospital Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Dropdown
                                    value={selectedHospital}
                                    name="hospitalName"
                                    options={hospitalOptions}
                                    filter
                                    optionLabel="name"
                                    placeholder="Select Council"
                                    onChange={(e) => onCollegeSelect(e.value)}
                                    className={errors['hospitalName'] && 'p-invalid'}
                                />
                                <small className="p-invalid-txt">{errors['hospitalName']}</small>
                            </div>

                            <div className="field col-12 md:col-4">
                                <label htmlFor="Address">
                                    Address <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputTextarea value={!window.cn(hospitalData?.address) ? hospitalData?.address : ''} name="address" disabled={true} rows={4} className={errors['address'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['address']}</small>
                            </div>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col-12 md:col-12">
                                <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                                    <Button label="Clear" icon="pi pi-times" className="p-button-secondary mr-2" onClick={() => clearAll()} />
                                    <Button label="Save" icon="pi pi-check" onClick={() => addhospitalData()} loading={addLoader} disabled={buttonVisible} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={tansferInList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={tansferInList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {PracticalTrainingListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'created_at') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'FileNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'Address') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={commonNameTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {PracticalTrainingListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {loading === true ? <Loader /> : ''}

        </>
    );
};
